import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../../components/Layout';
import Content from '../../../components/Pages/BusinessPartners/View';

const { displayName } = config;

export default function BusinessPartnerView(): React.ReactNode | null {
  document.title = `${displayName}: Business Partner view`;

  return (
    <Layout
      title="Business Partner view"
    >
      <Content />
    </Layout>
  );
}
